import { Callout } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

export const InconsistencyCallout = () => {
  const { t } = useTranslation('global');

  return (
    <Callout
      variant="warning"
      title={t(
        'submitMyInvoice.scheduled.wireTransfer.inconsistentMatchingResults.title',
      )}
    >
      {t(
        'submitMyInvoice.scheduled.wireTransfer.inconsistentMatchingResults.description',
      )}
    </Callout>
  );
};
